<div class="ne-fonts-list">
  {#each availableFonts as font}
    <slot font={font}></slot>
  {/each}
</div>

<style>
  .ne-fonts-list {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
  }
</style>

<script>
  import { store } from '../stores';
  const availableFonts = [...$store.fontFaces];
</script>
